import { sendPaymentViaLink, findDoctorRatecard, getCompanyRateCardsData, getCompanyRateCardsByPlanData, fetchAmbulance, updateAmbulanceInfo, createAmbulanceRequest } from "../../pages/actions/actions";
// import { useSseTrigger } from "../UseSseTrigger/UseSseTrigger";
import { useEffect, useState } from "react";
import { UseGetStoreData } from "../getStoreData/UseGetStoreData";
import { useModal } from "../../components/organisms/modalProvider/ModalProvider";
import { ShowAlert } from "../../utils/showAlert";
import { updateTicket } from "../../pages/actions/actions";
import { currentDateTime } from "../../utils/helper";
import { useDispatch } from "react-redux";
import { useQueryClient } from "@tanstack/react-query";
import { getSingleBenData } from "../../http";
import { fareCalculationApi } from "../../http";
import { ticketUpdateStatusSuccess } from "../../redux/ticketUpdateSlice/ticketUpdateSlice";




interface Doctor {
    _id: string;
    price: number;
    doctorType: string
}

export const usePaymentLink = ({ component, extraChargesAmount }: any) => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const [error, setError] = useState('');
    const [amount, setAmount] = useState<number | null>(null);
    const [number, setNumber] = useState<any>(null)
    const [email, setEmail] = useState(null)
    const { getTicketData, getAmbulanceDistanceBetween, getTicketUpdateData } = UseGetStoreData();
    const [selectedDetails, setSelectedDetails] = useState<any>([]);
    // const { paymentBtnStatus_Ambulance,paymentBtnStatus_Doctor } = usePaymentStatus()
    const [isLoading, setIsLoading] = useState(false);
    const { hideModal } = useModal();
    const [ambulanceType, setAmbulanceType] = useState<any>(null)
    const [typeOfDoctorList, settypeOfDoctorList] = useState<Doctor | any>([])
    const [doctorId, setdoctorId] = useState<string>("")
    const [doctorPayment, setDoctorPayment] = useState(0)
    const [isEditable, setIsEditable] = useState(false);
    const [pocorateCard, setPocoRateCard] = useState<any[]>([])
    const [selectedPocoRateCard, setSelectedPocoRateCard] = useState<string>("");
    const [selectedAmbulanceRateCard, setSelectedAmbulanceRateCard] = useState<any>([])
    // const {handleAmbulanceBooking} = useAmbulanceBooking();

    useEffect(() => {
        const fetchDoctorList = async () => {
            const doctorList = await findDoctorRatecard()

            settypeOfDoctorList(doctorList.data)
            setdoctorId(doctorList.data[0]?.doctorType || "No Doctor available")
            setDoctorPayment(doctorList.data[0]?.price || 0)
        }
        const fetchPocoAmbulanceRateCard = async () => {
            const companyId = getTicketData?.companyId;
            if (!companyId) return;

            let response;
            let companyResponse: any[] = [];
            let isPlanBased = false;
            const benId = getTicketData?.patient?.id;
            if (benId) {
                try {
                    const benRes = await getSingleBenData(benId);
                    const planId = benRes?.data?.data?.insurancePolicies?.[0]?.planId;
                    if (planId) {
                        const planResponse = await getCompanyRateCardsByPlanData(companyId, planId);
                        const hasPlanMatch = planResponse?.some((item: any) => item.planId === planId);
                        if (hasPlanMatch) {
                            response = planResponse;
                            isPlanBased = true;
                        }
                    }
                } catch (e) {
                    // fallback below
                }
            }
            // Always fetch company cards for fallback cascade
            try {
                companyResponse = await getCompanyRateCardsData(companyId);
            } catch (e) {
                companyResponse = [];
            }
            if (!response || response.length === 0) {
                response = companyResponse;
            }
            const hasMapped = response.some((item: any) => item.isDefaultMapping === false);
            const filtered = hasMapped
                ? response.filter((item: any) => item.isDefaultMapping === false)
                : response;

            // Helper: apply tier filter to a list of cards
            const ambulanceCount = getTicketData?.beneficiaryAmbulanceCount;
            const applyTierFilter = (cards: any[]) => {
                const hasTier = cards.some((card: any) => card.minCount !== undefined || card.maxCount !== undefined);
                if (!hasTier || ambulanceCount === undefined || ambulanceCount === null) return cards;

                // First pass: find cards with ranges that match the count
                const rangeMatched = cards.filter((card: any) => {
                    const hasMin = card.minCount !== undefined && card.minCount !== null;
                    const hasMax = card.maxCount !== undefined && card.maxCount !== null;
                    if (!hasMin && !hasMax) return false; // skip no-range cards in first pass
                    const cardScope = card.countScope;
                    const count = cardScope === 'subscriber'
                        ? getTicketData?.ambulanceCount
                        : ambulanceCount;
                    if (count === undefined || count === null) return false;
                    if (hasMin && hasMax) return count >= card.minCount && count < card.maxCount;
                    if (hasMin && !hasMax) return count >= card.minCount;
                    if (!hasMin && hasMax) return count < card.maxCount;
                    return false;
                });

                // If at least one range card matched, show only those
                if (rangeMatched.length > 0) return rangeMatched;

                // No range card matched — fall back to no-range cards
                const noRangeCards = cards.filter((card: any) =>
                    (card.minCount === undefined || card.minCount === null) &&
                    (card.maxCount === undefined || card.maxCount === null)
                );
                return noRangeCards; // return empty if no no-range cards — cascade handles the rest
            };

            // Cascading tier filter: plan → company → default
            let finalFiltered = applyTierFilter(filtered);

            if (finalFiltered.length === 0 && isPlanBased) {
                // Plan cards didn't match — try company-specific cards
                const companyMapped = companyResponse.filter((item: any) => item.isDefaultMapping === false);
                if (companyMapped.length > 0) {
                    const companyTierFiltered = applyTierFilter(companyMapped);
                    if (companyTierFiltered.length > 0) {
                        finalFiltered = companyTierFiltered;
                    }
                }
            }

            if (finalFiltered.length === 0) {
                // Still nothing — fall back to global DEFAULT cards
                const defaultCards = companyResponse.filter((card: any) => card.isDefaultMapping === true);
                finalFiltered = defaultCards.length > 0 ? defaultCards : filtered;
            }

            setPocoRateCard(finalFiltered);
        }
        fetchPocoAmbulanceRateCard()
        fetchDoctorList()

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [getTicketData?.companyId, getTicketData?.patient?.id])

useEffect(() => {
    if (pocorateCard.length === 0) return;

    const reduxRateCard = getTicketUpdateData?.selectedPocoRateCard;
    const reduxAmbulanceType = getTicketUpdateData?.selectedAmbulanceType;

    const matchedCard = reduxRateCard
        ? pocorateCard.find((card: any) => card.rateCardName === reduxRateCard)
        : null;

    // Tier-based auto-selection using minCount/maxCount
    let tierCard = null;
    if (!matchedCard) {
        const hasTier = pocorateCard.some((card: any) => card.minCount !== undefined || card.maxCount !== undefined);
        if (hasTier) {
            const firstTierCard = pocorateCard.find((card: any) => card.minCount !== undefined || card.maxCount !== undefined);
            const scope = firstTierCard?.countScope;
            const ambulanceCount = scope === 'subscriber'
                ? getTicketData?.ambulanceCount
                : getTicketData?.beneficiaryAmbulanceCount;

            if (ambulanceCount !== undefined && ambulanceCount !== null) {
                tierCard = pocorateCard.find((card: any) => {
                    const hasMin = card.minCount !== undefined && card.minCount !== null;
                    const hasMax = card.maxCount !== undefined && card.maxCount !== null;
                    if (!hasMin && !hasMax) return false;
                    if (hasMin && hasMax) return ambulanceCount >= card.minCount && ambulanceCount < card.maxCount;
                    if (hasMin && !hasMax) return ambulanceCount >= card.minCount;
                    if (!hasMin && hasMax) return ambulanceCount < card.maxCount;
                    return false;
                }) || null;
            }
        }
    }

    const cardToUse = matchedCard || tierCard || pocorateCard.find((card: any) => card.isDefaultMapping) || pocorateCard[0];

    if (cardToUse) {
        setSelectedPocoRateCard(cardToUse.rateCardName);
        setSelectedAmbulanceRateCard([cardToUse]);
    }

    if (reduxAmbulanceType) {
        setAmbulanceType(reduxAmbulanceType);
    }
}, [pocorateCard, getTicketUpdateData?.selectedPocoRateCard, getTicketUpdateData?.selectedAmbulanceType, getTicketData?.ambulanceCount, getTicketData?.beneficiaryAmbulanceCount]);




    useEffect(() => {
        const calculateAmount = () => {
            try {
                if (selectedPocoRateCard) {
                    const ambulanceRateCard: any = pocorateCard.find(
                        (rateCard: any) => rateCard.rateCardName === selectedPocoRateCard
                    )
                    const distanceBetween = Math.round(parseFloat(getAmbulanceDistanceBetween));
                    const selectedTypeForRateCard = ambulanceRateCard?.rateCards[ambulanceType]

                    if (!selectedTypeForRateCard) {
                        setAmount(null);
                        return;
                    }

                    const rateCard = selectedTypeForRateCard.find((rateCard: any) => {
                        const { rateType, distanceRange } = rateCard;

                        if (rateType === 'flat') {
                            const [lowerRange, upperRange] = distanceRange.split('-').map(parseFloat);
                            return distanceBetween >= lowerRange && distanceBetween <= upperRange;
                        }

                        if (rateType === 'per km') {
                            if (distanceRange.includes('Above')) {
                                const upperRange = parseFloat(distanceRange.split(' ')[1]);
                                return distanceBetween > upperRange;
                            } else {
                                const [lowerRange, upperRange] = distanceRange.split('-').map(parseFloat);
                                return distanceBetween >= lowerRange && distanceBetween <= upperRange;
                            }
                        }

                        return false;
                    });

                    if (!rateCard) {
                        alert('Rate card not found for selected ambulance provider or ambulance type.');
                    }
                    else if (rateCard.rateType === 'flat') {
                        setAmount(rateCard.prices);
                    }
                    else if (rateCard.rateType === 'per km') {
                        setAmount(rateCard.prices * distanceBetween);
                    }
                }
                else {
                    setAmount(null);
                }
            }
            catch (error: any) {
                console.error("Error in finding rate card: " + error.message);
                setAmount(null);
            }
        }

        if (ambulanceType) {
            calculateAmount();
        }
    }, [ambulanceType, selectedPocoRateCard, pocorateCard, getAmbulanceDistanceBetween])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        const callFareCalculationApi = async () => {
            if (selectedPocoRateCard && ambulanceType && getAmbulanceDistanceBetween) {
                const distanceMatch = getAmbulanceDistanceBetween?.match(/[\d.]+/);
                const distance = distanceMatch ? parseFloat(distanceMatch[0]) : 0;

                try {
                    const payload: any = {
                        ambulanceType: ambulanceType,
                        distance: distance,
                        rateCardName: selectedPocoRateCard
                    };

                    // ALWAYS include assistance options from Redux
                    const assistance = getTicketUpdateData?.typeOfAssistanceRequired;
                    if (assistance) {
                        if (assistance.wheelChair) payload.wheelchair = true;
                        if (assistance.stretcher) payload.stretcher = true;
                        if (assistance.paramedic) payload.paramedic = true;
                        if (assistance.DoctorOnBoard) payload.doctorOnBoard = true;
                        if (assistance.additionalHelp && assistance.numberOfHelpers) {
                            payload.helper = assistance.numberOfHelpers;
                        }
                    }

                    const result = await fareCalculationApi(payload);
                    const fareData = result.data?.data;
                    const totalAmount = fareData?.totalFare || 0;

                    setAmount(totalAmount);

                    dispatch(ticketUpdateStatusSuccess({
                        estimatedFare: fareData,
                        selectedAmbulanceType: ambulanceType,
                        selectedPocoRateCard: selectedPocoRateCard,
                        extraCharges: fareData?.extraCharges || 0
                    }));
                } catch (error) {
                    console.error("Error calling fare calculation API:", error);
                }
            }
        };

        callFareCalculationApi();
    }, [selectedPocoRateCard, ambulanceType,getTicketUpdateData?.typeOfAssistanceRequired,getAmbulanceDistanceBetween,dispatch]);



    function buildPayload() {
        let benList = [];
        if (getTicketData?.patient) {
            benList.push({
                id: "patient",
                name: getTicketData?.patient?.fullName,
                mobile: getTicketData?.patient?.mobile,
                email: getTicketData?.patient?.email
            });
            if (getTicketData?.patient?.emergencyContacts) {
                getTicketData?.patient?.emergencyContacts.forEach((item: any, index: number) => {
                    benList.push({
                        id: `em-${index + 1}`,
                        name: item.fullName,
                        mobile: item.mobile
                    })
                })
            };
        } if (getTicketData?.poc) {
            benList.push({
                id: "poc",
                name: getTicketData?.poc?.fullName,
                mobile: getTicketData?.poc?.mobile
            })
        };
        return benList;
    };
    const benList = buildPayload();
    const handleCatchAmount = (e: any) => {
        let value = e.target.value;
        let formateOnlyDigits = value.replace(/\D/g, '');
        // console.log('formateOnlyDigits:', formateOnlyDigits);
        if (formateOnlyDigits && formateOnlyDigits <= 0) {
            ShowAlert("warning", "Please enter valid amount");
        }
        setAmount(formateOnlyDigits);
    };
    const handleCollectMobileNumber = (e: any) => {
        let value = e.target.value;
        let formateOnlyDigits = value.replace(/\D/g, '');
        // console.log('formateOnlyDigits:', formateOnlyDigits);
        if (formateOnlyDigits && formateOnlyDigits <= 0) {
            ShowAlert("warning", "Please enter valid amount");
        }
        setNumber(formateOnlyDigits);
    };
    const handleCollectEmail = (e: any) => {
        const value = e.target.value;
        setEmail(value);
        if (validateEmail(value)) {
            setError('');
        } else {
            setError('Invalid email format');
        };
    };
    const validateEmail = (email: any) => {
        // Simple regex for email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
    ///
    const buildPayloadForPaymentLink = async () => {
        setIsLoading(true);
        // console.log('getTicketData:', getTicketData);
        let persistRoot = localStorage.getItem('persist:root') || '';
        let rootState = persistRoot ? JSON.parse(persistRoot) : {};
        let benificaryData = rootState?.beneficiary ? JSON.parse(rootState.beneficiary) : {};
        let benDatas = benificaryData?.benData ?? [];
        let benData = benDatas.find((data: any) => data?._id === getTicketData?.patient?.id);
        if (!benData && getTicketData?.patient?.id) {
            const singleBenData = await getSingleBenData(getTicketData?.patient?.id);
            benData = singleBenData?.data?.data;
        }
        const min = 1000000; // Starting range (e.g., 1 million)
        const max = 20000000;
        let basePayload: any = {
            amount: extraChargesAmount || (component === 'doctor-consultation' ? +doctorPayment : (amount ? +amount : doctorPayment)),
            payment_status: "created",
            currency: "INR",
            notes: {
                order_by: component
            },
            order_id: Math.floor(Math.random() * (max - min + 1)) + min.toString(),
            description: component,
            callback_url: "https://pococare.com",//in backend i changed these url based on the env//
            callback_method: "get",
            receipt: component,
            ticket_id: getTicketData?._id?.toString(),
            beneficiary: {
            },
            otherDetails: {
                ...((getTicketData?.subscriber?.id || benData?.subscriberId) && {
                    subscriberId: getTicketData?.subscriber?.id || benData?.subscriberId
                })
            },
        }
        if (selectedDetails.length) {
            selectedDetails.forEach((item: any, index: number) => {
                if (item.email) {
                    basePayload.beneficiary = {
                        name: item.name,
                        mobile: item.mobile,
                        email: item.email
                    };
                } else {
                    basePayload.beneficiary = {
                        name: item.name,
                        mobile: item.mobile
                    };
                }
            })
        } else {
            if (email) {
                basePayload.beneficiary = {
                    name: getTicketData?.patient?.fullName,
                    mobile: number,
                    email: email
                };
            } else {
                basePayload.beneficiary = {
                    name: getTicketData?.patient?.fullName,
                    mobile: number
                };
            }

            // Adding few additional details if payment is for ambulance

            if (component === 'Ambulance') {
                basePayload.otherDetails = {
                    ...basePayload.otherDetails,
                    pocorateCardid: selectedAmbulanceRateCard?.[0]?._id,
                    rateCardName: selectedPocoRateCard,
                    ambulanceType: ambulanceType,
                    pickupLocation: getTicketData?.patientLocation?.address,
                    dropLocation: getTicketData?.hospitalInfo?.address,
                    distanceBetween: getAmbulanceDistanceBetween
                }
            }


            // Adding few additional details if payment is for doctor-consultation
            if (component === 'doctor-consultation') {
                basePayload.otherDetails = {
                    ...basePayload.otherDetails,
                    doctorId: doctorId,
                }
            }
        }
        try {

            await sendPaymentViaLink(basePayload);
            const payload: any = {

                notes: [...getTicketData?.notes, {
                    date: currentDateTime(),
                    message: `PaymentLink Send for ${component}`
                }]
            };
            if (component === 'Ambulance') {
                payload["ambulancePayment"] = { status: "created", amount: basePayload.amount }
            }
            await updateTicket(getTicketData._id, payload, dispatch);
            await queryClient.invalidateQueries(
                {
                    queryKey: ['getOrdersByTicketId', getTicketData._id],
                    exact: true,
                    refetchType: 'all',
                },
            );
            hideModal();
            setEmail(null);
            setNumber(null);
            setAmount(null);
            setAmbulanceType(null);
            setSelectedPocoRateCard("")
            setIsLoading(false);
            setSelectedDetails([]);
            if (component === 'Ambulance') {
                const response = await fetchAmbulance(getTicketData?._id)
                if (response?.length === 0) {
                    const payload = {
                        ticket_id: `${getTicketData?._id}`,
                        paymentStatus: "created",
                        amount: Number(amount)
                    }
                    await createAmbulanceRequest(payload);
                } else {
                    await updateAmbulanceInfo(getTicketData?._id, { paymentStatus: "created", amount: Number(amount) })
                }

            }
        } catch (e: any) {

            setEmail(null);
            setNumber(null);
            setAmount(null);
            setAmbulanceType(null);
            setSelectedPocoRateCard("")
            setSelectedDetails([]);
            console.log('error:', e);
            setIsLoading(false);
            // console.log("e?.response?.data?.message[0]", e?.response?.data?.message[0])
            // console.log("e?.message", e?.message)
            return ShowAlert("warning", e?.response?.data?.message[0] || e?.message || "some error in sending payment link");
        };
    };
    const handleSendPaymentLink = async () => {

        if (!doctorPayment) {
            return ShowAlert("warning", "Please enter valid amount");
        }
        else if (!Boolean(Number(amount))) {
            if (selectedPocoRateCard) {
                return ShowAlert("warning", "Please enter valid amount");
            }
        }
        else if (!selectedDetails.length && !number && !email) {
            return ShowAlert("warning", "Please enter valid email or mobile or select beneficiary");
        } else if (selectedDetails.length && (number || email)) {
            setEmail(null)
            setNumber(null)
            return ShowAlert("warning", "either (email , mobile) or select beneficiary");
        } else if (isLoading) {
            return ShowAlert("warning", "Please wait Progress..");
        }
        await buildPayloadForPaymentLink();
    };
    const handleSelectChange = (value: any) => {
        const selectedItems = benList.filter((item) => value.includes(item.id));
        if (selectedItems.length > 0) {
            setSelectedDetails(selectedItems);
        } else {
            setSelectedDetails([])
        }
    };

    const handleAmbulanceTypeChange = (value: any) => {
        if (value) {
            setAmbulanceType(value.toString());
        }
        else {
            setAmbulanceType(null);
        }
    }

    // handling amount editing
    const handleAmountEditing = () => {
        if (amount) {
            setIsEditable(true);
        }
    }

    const handleAmountBlur = () => {
        setIsEditable(false);
    }
    const handleAmountEditingForDoctor = () => {
        setIsEditable(true)


    }
    const handleCatchAmountForDoctor = (e: any) => {

        let value = e.target.value;
        let formateOnlyDigits = value.replace(/\D/g, '');
        // console.log('formateOnlyDigits:', formateOnlyDigits);
        if (formateOnlyDigits && formateOnlyDigits <= 0) {
            ShowAlert("warning", "Please enter valid amount");
        }
        setDoctorPayment(value)


    }

    const handleRateCardrChange = (value: string) => {
        setSelectedPocoRateCard(value);
        const current = pocorateCard.filter(({ rateCardName }) => rateCardName === value);
        setSelectedAmbulanceRateCard(current);

        // Reset ambulance type to the first ambulanceType of the newly selected rate card
        const selectedCard = current[0];
        if (selectedCard?.ambulanceTypes && Array.isArray(selectedCard.ambulanceTypes) && selectedCard.ambulanceTypes.length > 0) {
            const firstType = String(selectedCard.ambulanceTypes[0]);
            setAmbulanceType(firstType);
            dispatch(ticketUpdateStatusSuccess({
                selectedPocoRateCard: value,
                selectedAmbulanceType: firstType
            }));
        } else {
            setAmbulanceType(null);
            dispatch(ticketUpdateStatusSuccess({
                selectedPocoRateCard: value
            }));
        }
    }


    useEffect(() => {
        if (getTicketUpdateData?.estimatedFare?.totalFare) {
            setAmount(getTicketUpdateData.estimatedFare.totalFare);
        }
        if (getTicketUpdateData?.selectedAmbulanceType) {
            setAmbulanceType(getTicketUpdateData.selectedAmbulanceType);
        }
    }, [getTicketUpdateData?.estimatedFare, getTicketUpdateData?.selectedAmbulanceType]);

    useEffect(() => {
        setSelectedDetails([]);
        setEmail(null);
        setNumber(null);
        //setSelectedPocoRateCard("");
        // Restore values from Redux
        if (getTicketUpdateData?.estimatedFare?.totalFare) {
            setAmount(getTicketUpdateData.estimatedFare.totalFare);
        }
        if (getTicketUpdateData?.selectedAmbulanceType) {
            setAmbulanceType(getTicketUpdateData.selectedAmbulanceType);
        }

        if (typeOfDoctorList && typeOfDoctorList.length > 0) {
            const selectedDoctor = typeOfDoctorList.find((doctor: Doctor) => doctor.doctorType === doctorId);
            if (selectedDoctor) {
                setDoctorPayment(selectedDoctor.price);
            }
        }
    }, [hideModal, typeOfDoctorList, doctorId, getTicketUpdateData])


    return {
        amount, error, number, handleSendPaymentLink, email, handleCollectMobileNumber, handleCatchAmount, handleCollectEmail, handleSelectChange, benList, isLoading, selectedDetails,
        handleAmbulanceTypeChange, ambulanceType, handleAmountBlur, isEditable, handleAmountEditing, typeOfDoctorList, doctorId, doctorPayment, handleAmountEditingForDoctor, handleCatchAmountForDoctor, pocorateCard, handleRateCardrChange, selectedPocoRateCard, selectedAmbulanceRateCard

    }
}
